































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import { AccountModule } from '@/store/modules/account';
import { GetScSupplierDetail, HasSavedCurrentScSupplierEnterpriseInfo } from '../api/sc/index';

type SupplierTag = {
  code: string;
  name: string;
};

type SupplierSku = {
  id: string;
  sn: string;
  description: string;
  sizeText: string;
  materialText: string;
  craftText: string;
  imageUrl: string;
  referencePrice: string;
  approvalStatus: number | null;
  firstCategoryCode: string;
};

type SupplierDevice = {
  id: string;
  brandName: string;
  modelName: string;
  quantity: number;
};

type SupplierDetail = {
  enterpriseSn: string;
  name: string;
  logoUrl: string;
  locationText: string;
  supplierIntro: string;
  supplierMainProducts: string;
  tagList: SupplierTag[];
  deviceList: SupplierDevice[];
  skuList: SupplierSku[];
};

function normalizeArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}

function readRouteQueryValue(value: string | string[] | undefined): string {
  if (Array.isArray(value)) {
    return value[0] || '';
  }
  return value || '';
}

function isSkuApprovedForDisplay(item: SupplierSku): boolean {
  return item.approvalStatus === 1;
}

function filterApprovedCategorySkuList(skuList: SupplierSku[], firstCategoryCode: string): SupplierSku[] {
  return skuList.filter(item => isSkuApprovedForDisplay(item) && (firstCategoryCode ? item.firstCategoryCode === firstCategoryCode : true));
}

function buildSupplierDetail(detail: any, firstCategoryCode = ''): SupplierDetail {
  const rawDetail = detail || {};
  return {
    enterpriseSn: rawDetail.enterpriseSn || '',
    name: rawDetail.name || '',
    logoUrl: rawDetail.logoUrl || '',
    locationText: rawDetail.locationText || '',
    supplierIntro: rawDetail.supplierIntro || '',
    supplierMainProducts: rawDetail.supplierMainProducts || '',
    tagList: normalizeArray<SupplierTag>(rawDetail.tagList),
    deviceList: normalizeArray<SupplierDevice>(rawDetail.deviceList),
    skuList: filterApprovedCategorySkuList(normalizeArray<SupplierSku>(rawDetail.skuList), firstCategoryCode),
  };
}

@Component({
  components: {},
})
export default class SupplyChainDetail extends Vue {
  defaultLogoUrl = 'https://cdn-h.gongfudou.com/Epson/avatar.png';
  chatQrCodeUrl = 'https://cdn-h.gongfudou.com/Epson/wechat_qrcoder.png';
  detailLoading = false;
  selectedSupplier: SupplierDetail | null = null;
  firstCategoryCode = '';

  get skuEmptyText() {
    return this.firstCategoryCode ? '该品类暂无已审核通过商品。' : '该供应商暂无已上架商品。';
  }

  @Watch('$route', { immediate: true })
  async onRouteChange() {
    await this.fetchDetail();
  }

  async fetchDetail() {
    const enterpriseSn = readRouteQueryValue(this.$route.query.enterpriseSn as string | string[] | undefined);
    const firstCategoryCode = readRouteQueryValue(this.$route.query.firstCategoryCode as string | string[] | undefined);
    this.firstCategoryCode = firstCategoryCode;
    if (!enterpriseSn) {
      this.selectedSupplier = null;
      return;
    }

    this.detailLoading = true;
    try {
      const res = await GetScSupplierDetail({
        enterpriseSn,
        firstCategoryCode: firstCategoryCode || undefined,
      });
      this.selectedSupplier = buildSupplierDetail(res, firstCategoryCode);
    } catch (error) {
      this.selectedSupplier = null;
    } finally {
      this.detailLoading = false;
    }
  }

  async handleApplyEntry() {
    if (!AccountModule.isLogined) {
      this.$message.warning('请先登录后再申请入驻');
      this.$router.push('/login');
      return;
    }
    const hasSavedEnterpriseInfo = await HasSavedCurrentScSupplierEnterpriseInfo();
    this.$router.push({
      path: '/supplyChainApply',
      query: hasSavedEnterpriseInfo ? { step: '2' } : {},
    });
  }

  handleBackToList() {
    this.$router.push('/supplyChain');
  }

  formatDeviceName(item: SupplierDevice) {
    return [item.brandName, item.modelName].filter(Boolean).join(' ') || '未命名设备';
  }

  handleChatSupplier() {
    if (!this.selectedSupplier) {
      return;
    }
    const qrCodeNode = this.$createElement('div', { class: 'supply-chain-chat-dialog' }, [
      this.$createElement('img', {
        class: 'supply-chain-chat-qrcode',
        attrs: {
          src: this.chatQrCodeUrl,
          alt: '微信二维码',
        },
      }),
    ]);

    this.$msgbox({
      title: '立即私聊',
      message: qrCodeNode,
      customClass: 'supply-chain-chat-message-box',
      confirmButtonText: '关闭',
      center: true,
    }).catch(() => undefined);
  }
}
